export default __webpack_public_path__ + "static/Group 626-cddd2ffe029a4b144ce847e56462b368.png";